import { render, staticRenderFns } from "./ServerTable.vue?vue&type=template&id=44a618e4"
import script from "./ServerTable.vue?vue&type=script&lang=js"
export * from "./ServerTable.vue?vue&type=script&lang=js"
import style0 from "./ServerTable.vue?vue&type=style&index=0&id=44a618e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports